module.exports = __webpack_public_path__ + "static/image/history/pc/202311@x3.jpg?63a02159";